import { getCanvasDocument } from '../../env';
import type { ImageFormat, TSize } from '../../typedefs';
import { CanvasFilterError } from '../internals/console';

export const createCanvasElement = (): HTMLCanvasElement => {
  const element = getCanvasDocument().createElement('canvas') as HTMLCanvasElement;
  if (!element || typeof element.getContext === 'undefined') {
    throw new CanvasFilterError('Failed to create canvas element');
  }
  return element;
};

export const createImage = (): HTMLImageElement =>
  getCanvasDocument().createElement('img') as HTMLImageElement;

export const copyCanvasElement = (canvas: HTMLCanvasElement): HTMLCanvasElement => {
  const newCanvas = createCanvasElementFor(canvas);
  newCanvas.getContext('2d')?.drawImage(canvas, 0, 0);
  return newCanvas;
};

export const createCanvasElementFor = (
  canvas: HTMLCanvasElement | ImageData | HTMLImageElement | TSize,
): HTMLCanvasElement => {
  const newCanvas = createCanvasElement();
  newCanvas.width = canvas.width;
  newCanvas.height = canvas.height;
  return newCanvas;
};

export const toDataURL = (
  canvasEl: HTMLCanvasElement,
  format: ImageFormat,
  quality: number,
): string => canvasEl.toDataURL(`image/${format}`, quality);

export const isHTMLCanvas = (
  canvas?: HTMLCanvasElement | string,
): canvas is HTMLCanvasElement => {
  return !!canvas && (canvas as HTMLCanvasElement).getContext !== undefined;
};

export const toBlob = (
  canvasEl: HTMLCanvasElement,
  format?: ImageFormat,
  quality?: number,
): Promise<Blob | null> =>
  new Promise((resolve) => {
    canvasEl.toBlob(resolve, `image/${format}`, quality);
  });
